module.exports = __webpack_public_path__ + "static/img/icon_redeem.fa8567a3.svg";